import React, { useRef, useMemo } from 'react';
import useDuperbrowseScrollRestoration from '../../Duperbrowse/hooks/useDuperbrowseScrollRestoration';
import gridStyle from './GridRow.scss';
var HiddenGridRow = function (_a) {
    var start = _a.start, end = _a.end, getDuperbrowseItemId = _a.getDuperbrowseItemId, marginTop = _a.marginTop, height = _a.height;
    var itemIds = useMemo(function () {
        return getDuperbrowseItemId
            ? Array(end - start)
                .fill(0)
                .map(function (_, i) { return getDuperbrowseItemId(i + start); })
            : [];
    }, [start, end, getDuperbrowseItemId]);
    var rowRef = useRef(null);
    useDuperbrowseScrollRestoration(itemIds, rowRef);
    return (React.createElement("div", { className: gridStyle['row'], style: { marginTop: marginTop, height: height }, ref: rowRef }));
};
HiddenGridRow.displayName = 'HiddenGridRow';
export default HiddenGridRow;
//# sourceMappingURL=HiddenGridRow.js.map